import { SyntheticEvent } from "react";

export const handleSubmit = (event: SyntheticEvent): void => {
  event.preventDefault();
};
